export enum EmailSendSessionPeopleTypes {
  user = "user",
  group = "group",
  templateGroup = "templateGroup",
}
